import React, { useRef } from 'react';

import { ApiObject, Professor, Program, School } from 'app/types';
import Text from 'common/components/Text/Text';

import styles from 'features/explore/school/SchoolDetail.module.scss';
import { useMediaQuery } from 'react-responsive';
import Placeholder from 'assets/explore/placeholder.png';
import { entityIsSchool } from 'common/utils';

interface CompProps {
  entity?: ApiObject<School> | ApiObject<Program>;
  comesFromExplore?: boolean;
}

interface ProfessorCardProps {
  professor?: Professor;
}

const ProfessorCard = ({ professor }: ProfessorCardProps): React.ReactElement => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  return (
    <div className={styles.cardContainer}>
      <img
        src={professor?.photo ? professor.photo : Placeholder}
        alt={`Photo of ${professor?.name}`}
        className={styles.professorPhoto}
      />
      <Text
        size={isMobile ? 14 : 16}
        weight={600}
        inlineStyle={{ marginBottom: '8px', marginTop: '16px' }}
      >
        {professor?.name}
      </Text>
      <Text size={isMobile ? 14 : 16} weight={400}>
        {professor?.description}
      </Text>
    </div>
  );
};

export const TeachingSection = ({ entity, comesFromExplore }: CompProps): React.ReactElement => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const scrollTeaching = useRef<any>();
  return (
    <div className={styles.sectionContainer}>
      {entityIsSchool(entity?.data) && entity?.data.learning_and_teaching_description && (
        <>
          <h3 className={styles.subtitle}>Learning and Teaching</h3>
          <Text
            size={isMobile ? 14 : 16}
            weight={400}
            inlineStyle={{ color: '#19234F', marginTop: '16px', marginBottom: '32px' }}
          >
            {entity?.data.learning_and_teaching_description}
          </Text>
        </>
      )}
      {entity?.data.professors && entity?.data.professors.length > 0 && (
        <>
          <h3 className={styles.subtitle}>Professors and tutors</h3>
          {isMobile ? (
            <div
              className={`${styles.tagsContainer} row flex-row flex-nowrap mt-3 pt-1 gap-3`}
              ref={scrollTeaching}
            >
              {entity?.data.professors.map((professor: Professor) => (
                <div className={styles.professor} key={professor.id}>
                  <ProfessorCard professor={professor} />
                </div>
              ))}
            </div>
          ) : (
            <div className="row row-cols-1 row-cols-md-2 mt-5" ref={scrollTeaching}>
              {entity?.data.professors.map((professor: Professor) => (
                <div className={styles.professorDesktop} key={professor.id}>
                  <ProfessorCard professor={professor} />
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};
